// src/admin/components/HomePageConfig/FontStylesConfiguration.jsx
import React from "react";
import FontStyleControls from "../FontStyleControls";

export default function FontStylesConfiguration({ fontStyles, updateFontStyle }) {
  return (
    <div className="hcfg-card">
      <div className="hcfg-headrow">
        <h3>Global Font Styles (Applied to all sections)</h3>
      </div>

      <div className="hcfg-row">
        <div className="hcfg-col">
          <FontStyleControls
            title="Heading Styles (H1, H2, H3)"
            fontStyle={fontStyles.heading}
            onUpdate={(newStyle) => updateFontStyle("heading", newStyle)}
          />
        </div>
        <div className="hcfg-col">
          <FontStyleControls
            title="Sub-heading Styles"
            fontStyle={fontStyles.subHeading}
            onUpdate={(newStyle) => updateFontStyle("subHeading", newStyle)}
          />
        </div>
      </div>

      <div className="hcfg-row">
        <div className="hcfg-col">
          <FontStyleControls
            title="Content/Paragraph Styles"
            fontStyle={fontStyles.content}
            onUpdate={(newStyle) => updateFontStyle("content", newStyle)}
          />
        </div>
        <div className="hcfg-col">
          <FontStyleControls
            title="Button Styles"
            fontStyle={fontStyles.button}
            onUpdate={(newStyle) => updateFontStyle("button", newStyle)}
            showColor={true}
            showLineHeight={false}
          />
        </div>
      </div>

      <div className="hcfg-row">
        <div className="hcfg-col">
          <FontStyleControls
            title="Stats/Number Styles"
            fontStyle={fontStyles.stats}
            onUpdate={(newStyle) => updateFontStyle("stats", newStyle)}
          />
        </div>
        <div className="hcfg-col">
          <FontStyleControls
            title="Section Title Styles"
            fontStyle={fontStyles.sectionTitle}
            onUpdate={(newStyle) => updateFontStyle("sectionTitle", newStyle)}
          />
        </div>
      </div>

      <div className="hcfg-row">
        <div className="hcfg-col">
          <FontStyleControls
            title="Section Description Styles"
            fontStyle={fontStyles.sectionDescription}
            onUpdate={(newStyle) => updateFontStyle("sectionDescription", newStyle)}
          />
        </div>
      </div>

      <div className="hcfg-row">
        <div className="hcfg-col">
          <FontStyleControls
            title="Form Title Styles"
            fontStyle={fontStyles.formTitle}
            onUpdate={(newStyle) => updateFontStyle("formTitle", newStyle)}
          />
        </div>
        <div className="hcfg-col">
          <FontStyleControls
            title="Form Description Styles"
            fontStyle={fontStyles.formDescription}
            onUpdate={(newStyle) => updateFontStyle("formDescription", newStyle)}
          />
        </div>
      </div>

      <div className="hcfg-row">
        <div className="hcfg-col">
          <FontStyleControls
            title="Side Content Heading"
            fontStyle={fontStyles.sideContentHeading}
            onUpdate={(newStyle) => updateFontStyle("sideContentHeading", newStyle)}
          />
        </div>
        <div className="hcfg-col">
          <FontStyleControls
            title="Side Content Highlight"
            fontStyle={fontStyles.sideContentHighlight}
            onUpdate={(newStyle) => updateFontStyle("sideContentHighlight", newStyle)}
          />
        </div>
      </div>
    </div>
  );
}
